module.exports = __webpack_public_path__ + "img/table1-bg.62a741c9.svg";